import firebaseApp, { isProd } from '@config/firebase/config';
import { logError } from '@lib/logError';
import {
  getMessaging,
  getToken as getFcmToken,
  isSupported,
  onMessage,
} from 'firebase/messaging';

let messaging: ReturnType<typeof getMessaging> | null = null;

isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(firebaseApp);
  }
});

const PROD_VAPID_KEY =
  'BLBHFL1Vy4I6YVUz0G6wsdA7y5gZKRkRgoGFfjtAqqtyo9iP1Dtl337uPEn-Cbrql7LZF2P7Mu9IjZiyQDVLQ2k';
const DEV_VAPID_KEY =
  'BHxYOyothY3zWTPOF38rqLuGN-FS3d3HyEM9iIw2FqJM4B00xOe4QXGFOTiy2iFAIU4zAdnN99eThBOHph7h29g';

const VAPID_KEY = isProd ? PROD_VAPID_KEY : DEV_VAPID_KEY;

export const getToken = async (): Promise<void> => {
  try {
    if (!messaging) return;
    const currentToken = await getFcmToken(messaging, { vapidKey: VAPID_KEY });
    if (currentToken) {
      localStorage.setItem('deviceToken', currentToken);
    }
  } catch (error) {
    logError('push notification token', error);
  }
};

export interface FcmMessagePayload {
  notification?: {
    title?: string;
    body?: string;
  };
}

export const onMessageListener = (): Promise<FcmMessagePayload> => {
  return new Promise((resolve) => {
    if (!messaging) return;
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};
